import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Modal, ModalProps } from 'antd';
import React from 'react';
import ActionButton from './ActionButton';

export interface MsgModalProps extends ModalProps {
  open?: boolean;
  title?: string;
  close?: (...args: any[]) => void;
  content?: React.ReactNode;
  type?: 'success' | 'info' | 'error';
  needCancelBtn?: boolean;
  cancelText?: string;
}

const typeIcon = {
  success: <CheckCircleOutlined />,
  info: <ExclamationCircleOutlined />,
  error: <CloseCircleOutlined />,
};
const MsgModal: React.FC<MsgModalProps> = (p) => {
  const {
    open,
    title,
    onOk,
    okButtonProps,
    okText,
    content,
    type,
    close,
    cancelText,
    needCancelBtn = false,
    ...others
  } = p;
  return (
    <Modal
      width="420px"
      {...others}
      onCancel={() => close?.({ triggerCancel: true })}
      open={open}
      centered
      destroyOnClose
      bodyStyle={{ padding: '50px 40px' }}
      footer={null}
    >
      <div className="flex flex-col justify-center">
        {title && (
          <div className="flex text-18 text-secondary justify-center mb-6 font-medium">
            {title}
          </div>
        )}
        {type && (
          <>
            {React.cloneElement(typeIcon[type], {
              className: 'text-[46px] mb-[24px]',
            })}
          </>
        )}
        <div className="flex justify-center text-14 text-[#686868] mb-6">
          {content}
        </div>
        <div className="justify-center flex flex-row">
          <ActionButton
            actionFn={onOk}
            close={close}
            buttonProps={{
              className: `mr-3 ${needCancelBtn ? 'w-[190px]' : 'w-full'}`,
              size: 'large',
              type: 'primary',
              danger: true,
              shape: 'round',
              ...okButtonProps,
            }}
          >
            {okText || '确定'}
          </ActionButton>
          {needCancelBtn && (
            <ActionButton
              buttonProps={{
                className: 'w-[190px]',
                size: 'large',
                shape: 'round',
              }}
              actionFn={p.onCancel}
              close={close}
            >
              {cancelText || '取消'}
            </ActionButton>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default MsgModal;
